import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileService {

  isMobileView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  observe(): Observable<boolean> {
    return this.isMobileView.asObservable();
  }

  set(value: boolean) {
    this.isMobileView.next(value);
  }
}
